import { render } from "./PendingShiftsButton.vue?vue&type=template&id=2f03fd3c&scoped=true"
import script from "./PendingShiftsButton.vue?vue&type=script&lang=js"
export * from "./PendingShiftsButton.vue?vue&type=script&lang=js"

import "./PendingShiftsButton.vue?vue&type=style&index=0&id=2f03fd3c&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f03fd3c"]])

export default __exports__